import { useMemo } from 'react';
import { ChainFurnitureModel } from 'src/infrastructure/rest-api/api-types';
import { useFurnitureTypeQuery } from '../queries/useFurnitureTypesQuery';
import { useInventoryMasterDataQuery } from '../queries/useInventoryMasterDataQuery';

export interface InventoryMasterDataRow extends ChainFurnitureModel {
    typeName: string;
}

export const useInventoryMasterDataRows = () => {
    const { data: rows, loading: loadingData, error: imdError } = useInventoryMasterDataQuery();
    const { data: furnitureTypes, loading: loadingTypes, error: furnitureTypesError } = useFurnitureTypeQuery();

    const processedRows = useMemo(() => {
        if (!furnitureTypes || furnitureTypes.length === 0) {
            return [];
        }

        if (!Array.isArray(rows)) return [];

        return rows.map(
            (row) =>
                ({
                    ...row,
                    typeName: furnitureTypes.find((type) => type.id === row.furnitureTypeId)?.name,
                }) as InventoryMasterDataRow
        );
    }, [rows, furnitureTypes]);

    return { data: processedRows, loading: loadingData || loadingTypes, error: imdError || furnitureTypesError };
};
